import { SalesforcePicklistItem } from '../api/dto/salesforce-picklist-item';

const customerServiceWhitelist = [
  'Analytics',
  'AÜOffice',
  'CashLink',
  'Cockpit',
  'Connect',
  'EDL',
  'DMSplus',
  'Finance',
  'GDL',
  'Invoice Monitor',
  'IT + Hosting',
  'Kampagnenmanagement',
  'Onboarding',
  'Payroll',
  'PDL',
  'Recruit',
  'Verwaltung',
  'Zentraldisposition',
  'zOne-Payroll',
  'zOne-PDL',
];
export const filterCaseProductsByWhitelist = (items: SalesforcePicklistItem[]) =>
  items.filter((item) => customerServiceWhitelist.includes(item.value));
